/* eslint-disable react/require-default-props */
import React from 'react';
import { Container, Label, InputForm } from './styles';

interface Props {
  disabled?: boolean;
  value?: string;
  onChange: any;
  label?: string;
  placeholder?: string;
  type: string;
  error?: boolean;
  multiline?: boolean;
  maxRows?: number;
  required?: boolean;
}

const Input: React.FC<Props> = ({
  value, onChange, placeholder, type, error, disabled, multiline, maxRows, required, label,
}) => {
  const handleChange = (event: any) => {
    if (type === 'number') {
      onChange(event.target.value.replace(/[^0-9]/g, ''));
    } else {
      onChange(event.target.value);
    }
  };

  return (
    <Container>
      <Label>{label}</Label>
      <InputForm
        error={error}
        multiline={multiline || false}
        maxRows={maxRows || 1}
        margin="normal"
        required={required || false}
        disabled={disabled}
        fullWidth
        type={type}
        id="standard-error"
        placeholder={placeholder}
        onChange={handleChange}
        value={value}
        defaultValue={value}
      />
    </Container>
  );
};
export default Input;
